import { get } from 'lodash';

import { ActivatedRoute } from '@angular/router';

export function deepSearchRouteDataItem(route: ActivatedRoute, key: string): any {
  let value = get(route.snapshot.data, key);
  let parentRoute = route.parent;

  while (parentRoute && !value) {
    value = get(parentRoute.snapshot.data, key);
    parentRoute = parentRoute.parent;
  }

  return value;
}
